import updateDeliveryType from '@services/cart/updateDeliveryType';
import { SHOP_DELIVERY_TYPE } from '@shared/constants';
import { UPDATE_CART_DELIVERY_TYPE } from '@core/reducers/cart/actionTypes';
import updateCartProp from './updateCartProp';

const errorMessage =
  'Ocurrió un error al actualizar el tipo de entrega. Por favor intente nuevamente.';

const updateCartDeliveryType = ({ deliveryType, mute = false }) => async (
  dispatch,
  _,
  axios,
) =>
  dispatch(
    updateCartProp({
      updateProp: cartId =>
        updateDeliveryType({
          axios,
          pickUp: deliveryType === SHOP_DELIVERY_TYPE.PICK_UP,
          cartId,
        }),
      actionType: UPDATE_CART_DELIVERY_TYPE,
      errorMessage,
      mute,
    }),
  );

export default updateCartDeliveryType;
